<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end"
  colorScheme="dark"
  id="sidebar1"
  visible
>
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand [routerLink]="[]" class="w-100">
      <img src="assets/img/logo-white.png" alt="ShareWave" width="200" class="sidebar-brand-full" title="ShareWave" [class]="{icon: false}">
      <img src="assets/bin2024/user.png" alt="Logo diminuto" width="64" class="sidebar-brand-narrow" title="ShareWave">
    </c-sidebar-brand>
  </c-sidebar-header>

  <ng-scrollbar #scrollbar="ngScrollbar" class="overflow" pointerEventsMethod="scrollbar" visibility="hover">
    <c-sidebar-nav #overflow [navItems]="navItems" dropdownMode="close" compact />
  </ng-scrollbar>

  <div class="sidebar-version">
    ShareWave {{ version }}
  </div>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-admin-header
    [cShadowOnScroll]="'sm'"
    class="d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="sidebar1"
  />
  <!--plan expiry banner-->
  <app-plan-expiry-banner class="d-print-none" />
  <!--app-body-->
  <div class="body flex-grow-1 pt-3">
    <c-toaster placement="top-end" position="absolute" class="p-3">
      <c-toast #toast [visible]="errorMessage" class="align-items-center text-white" color="danger">
        <div class="d-flex border border-danger">
          <c-toast-body>
            <span class="fw-bold">{{ errorMessage }}</span>
          </c-toast-body>
          <button aria-label="close toast" cButtonClose class="me-2 m-auto" white (click)="toast.visible=false"></button>
        </div>
      </c-toast>
    </c-toaster>
    <c-container class="h-auto pb-3">
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-admin-footer />
</div>

<!--plan limit alert modal-->
<app-plan-limit-alert />

<!--plan expired modal bloqueo-->
<app-plan-expired-modal />

<!-- ── Overlay (z-index: 1040, debajo del panel) ── -->
<div
  class="sw-panel-overlay"
  [class.sw-panel-overlay--visible]="alertsPanel.isOpen()"
  (click)="alertsPanel.close()"
></div>

<!-- ── Panel lateral de alertas (z-index: 1050, fuera del stacking context del header) ── -->
@if (alertsPanel.isVisible) {
  <div
    class="sw-alerts-sidebar"
    [class.sw-alerts-sidebar--open]="alertsPanel.isOpen()"
    role="dialog"
    aria-label="Panel de alertas"
  >
    <!-- Header -->
    <div class="sw-alerts-sidebar__header">
      <div class="sw-alerts-sidebar__title">
        <svg cIcon name="cilBell" size="sm"></svg>
        Alertas del plan
      </div>
      <div class="d-flex align-items-center gap-2">
        @if (alertsPanel.hasAlerts()) {
          <span class="sw-alerts-sidebar__count">{{ alertsPanel.alertCount() }}</span>
        }
        <button class="sw-alerts-sidebar__close" (click)="alertsPanel.close()" aria-label="Cerrar panel">
          <svg cIcon name="cilX" size="sm"></svg>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="sw-alerts-sidebar__body">
      @if (alertsPanel.loading()) {
        <div class="sw-alerts-empty">
          <div class="sw-alerts-spinner"></div>
          <span>Cargando alertas...</span>
        </div>
      } @else if (!alertsPanel.hasAlerts()) {
        <div class="sw-alerts-empty">
          <svg cIcon name="cilCheckAlt" size="xl" class="sw-empty-icon"></svg>
          <span>Todo en orden</span>
          <small>No tienes alertas activas</small>
        </div>
      } @else {
        <ul class="sw-alerts-list" role="list">
          @for (alert of alertsPanel.alerts(); track alert.type) {
            <li class="sw-alert-item sw-alert-item--{{ alertsPanel.getSeverity(alert.type) }}" role="listitem">
              <div class="sw-alert-item__icon">
                <svg cIcon [name]="alertsPanel.getIcon(alert.type)" size="sm"></svg>
              </div>
              <div class="sw-alert-item__content">
                <span class="sw-alert-item__label">{{ alertsPanel.getLabel(alert.type) }}</span>
                <span class="sw-alert-item__message">{{ alert.message }}</span>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  </div>
}
